import ajaxInit from '@/router/ajax-init'
import store from '@/store'
import { gotoCxLogin } from '@/common/login'
import { gls } from '@/utils/storage'
import { handleVariable, isMobile } from '@/utils/tools'
import { dissoc } from 'ramda'
import router from '@/router/index'
import { checkJump } from '@/services/module/user'
import Vue from 'vue'
import { getToken } from '@/utils/app/js-bridge'
import { isInApp } from '@/utils/app-communication'

export default async function pageInit(to, next) {
  const replace = await setToken(to)

  /*重置路由去除页面token参数*/
  if (replace) {
    next({
      replace: true,
      ...replace
    })
    return
  }

  /*判断是否完成首次初始化*/
  if (!store.state.user.ajaxInit) {
    if (isInApp()) {
      const lt = await getToken()
      const { data, errCode } = lt
      const { token } = data
      console.log(`APP get token: `)
      console.log(data)
      if (errCode === 0) {
        await store.dispatch('user/updateToken', token)
      }
    } else {
      const token = gls('token')
      if (store.state.user.token != token && token) {
        window.location.reload()
        return
      }
    }
    await ajaxInit()
  }

  const redirectH5PageName = to.meta?.redirectH5PageName
  if (redirectH5PageName && to.name != redirectH5PageName && isMobile()) {
    next({
      name: redirectH5PageName,
      query: to?.query
    })
    return
  }
  const redirectUrl = to.meta?.redirectUrl
  if (redirectUrl && !isMobile()) {
    const res = await handleVariable(redirectUrl)
    window.open(res, '_blank')
    return
  }

  /*用户信息不存在,或者还没绑定手机号*/
  if (!store?.state?.user?.info?.phone) {
    /*访问的页面需要登录*/
    if (to?.meta?.requireLogin) {
      /*返回首页*/
      store.dispatch('route/loadingBefore', false)
      const callBackUrl = router.getAbsolutePath(to)
      gotoCxLogin({ callBackUrl })
      return
    }
  }
  next()
}

async function setToken(to) {
  const { query, name, params } = to
  const token = await parseToken(query)
  if (token) {
    console.log(to)
    await store.dispatch('user/updateToken', token)
    return {
      name,
      params,
      query: query |> dissoc('cx-token') |> dissoc('cx-temp-token')
    }
  }
  return false
}
async function parseToken(query) {
  const CXToken = query?.['cx-token']
  if (CXToken) {
    return CXToken
  }
  const tempToken = query?.['cx-temp-token']
  if (tempToken) {
    try {
      const {
        data: { data, errCode, errMsg }
      } = await checkJump({ code: tempToken })
      if (errCode !== 0) {
        Vue.prototype.$message.error(errMsg)
        return ''
      } else {
        console.log(data)
        return data
      }
    } catch (e) {
      console.log(e)
      return ''
    }
  }
}
